import React, { useEffect, useRef } from "react";
import styled from "styled-components";

const Scroll = () => {
  const textRef = useRef(null);

  useEffect(() => {
    // Force animation to start immediately when component mounts
    if (textRef.current) {
      // Add animate class for better control
      textRef.current.classList.add('animate');
      textRef.current.style.animationPlayState = 'running';
      
      // Restart animation to ensure it begins from the start
      textRef.current.style.animation = 'none';
      // Trigger reflow to ensure animation reset
      void textRef.current.offsetHeight;
      textRef.current.style.animation = 'scroll-left 25s linear infinite';
      
      // For mobile, use faster animation
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        textRef.current.style.animationDuration = '20s';
      }
    }
  }, []);

  return (
    <Container>
      <Text ref={textRef} className="animate">
        FREE SHIPPING ON ORDERS OVER $50 • NEW ARRIVALS EVERY WEEK • MEMBER EXCLUSIVE ACCESS • 
        NIKE MEMBERSHIP - JOIN FOR FREE • STUDENT DISCOUNT AVAILABLE • 30-DAY RETURN POLICY • 
      </Text>
    </Container>
  );
};

export default Scroll;

/* Styled Components */
const Container = styled.div`
  width: 100%;
  background: #111;
  overflow: hidden;
  white-space: nowrap;
  padding: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #333;
  position: relative;
`;

const Text = styled.div`
  display: inline-block;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  animation: scroll-left 25s linear infinite;
  animation-delay: 0s;
  animation-fill-mode: both;
  padding: 0 50px;
  will-change: transform;

  @keyframes scroll-left {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  /* Ensure animation starts immediately on load */
  &.animate {
    animation-play-state: running;
  }

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    font-size: 10px;
    letter-spacing: 0.5px;
    animation-duration: 20s;
  }
`;
